import { render, staticRenderFns } from "./CreateStory.vue?vue&type=template&id=5089ef76&scoped=true&"
import script from "./CreateStory.vue?vue&type=script&lang=js&"
export * from "./CreateStory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5089ef76",
  null
  
)

export default component.exports